export const uk = {
    'adaptive-banner': 'Адаптивное объявление',
    additions: 'Дополнения: {additionsList}',
    'banner-id': '№ {id}',
    duration: '{duration} сек'
};
